var handle_array = ["adonyss-quantumlite","zemits-ultranexx"];
 var productid_array = [""];
 var collectionid_array = [""];
 var product_tags_array = [""];
 var hide_price=1;
 var hide_ajaxaddtocart=1;
 var display_phone=1;
 var phone_no = '+44 (20) 45325922';
 var display_call_for_price = 1;
 var call_for_price_label = 'Enquire';
 var css_style_button='background-color: #f8a25a;color:#ffffff;';
 var enabled_captcha = 0;
 var site_key = '';
 var recaptcha_ver = 'v2';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Your Question';
 var submit_label ='Submit';
  var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =1;
  var enable_outofstock = 1;
 var price_selector='';
 var cart_selector='#AddToCart-product-template';
  var phone_no_label = 'or Call Us:';
 var required_field='phone';
 var contact_form_heading='Enquire about';
 var parent_selector='';
 var unavailable_label='Unavailable';
 var show_price='no';
 var enable_cfp_for_zero_price_prd='yes';
 var enable_cfp_for_all_products='no';
 var enable_cfp_soldout_products='yes';
 var hide_cfp_btn_on_collection='no';
 var hide_phone_no_on_collection='no';
 var enable_whatsapp = 1;
 var whatsapp_number = '+442086446377';
 var whatsapp_message = 'Hi a-esthetic.co.uk I am interested in this product. {product_url}. Price please ?';
 var hide_whatsapp_button_on_collection = 0;
 var whatsapp_button_text ='';
 var whatsapp_button_background_color ='#000000';
 var whatsapp_button_text_color ='#ffffff';
 var whatsapp_css_style_button ='';
 var phoneno_css_style_button ='';